export const toFixedWithoutRounding = (
  value: number,
  decimals: number = 4
): number => {
  const multiplier = Math.pow(10, decimals);
  return Math.floor(value * multiplier) / multiplier;
};
